import React from "react";
import { Button } from "./Button";

export function Footer({ onClick, children }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 w-full  pb-safe pt-2 px-4">
      <div className="max-w-[420px] mx-auto">
        <Button onClick={onClick} className="w-full">
          {children}
        </Button>
      </div>
    </div>
  );
}
